import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { default: String }

  connect() {
    console.log("Tabs controller connected")
    console.log("Tab targets:", this.tabTargets)
    console.log("Panel targets:", this.panelTargets)
    this.showDefaultTab()
  }

  showDefaultTab() {
    // Show default tab if specified, otherwise show first tab
    const defaultTab = this.defaultValue || this.tabTargets[0]?.dataset.tab
    console.log("Default tab:", defaultTab)
    if (defaultTab) {
      this.show({ currentTarget: { dataset: { tab: defaultTab } } })
    }
  }

  show(event) {
    // Use currentTarget first (proper event handling for the button)
    let selectedTab = event.currentTarget?.dataset?.tab
    
    // Fallback: traverse up to find tab button if currentTarget doesn't have data-tab
    if (!selectedTab) {
      const tabButton = event.target.closest('[data-tab]')
      selectedTab = tabButton?.dataset?.tab
    }
    
    if (!selectedTab) {
      console.warn('No valid tab found for click')
      return
    }
    
    console.log("Switching to tab:", selectedTab)

    // Update tab buttons
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tab === selectedTab
      console.log(`Tab ${tab.dataset.tab}: ${isActive ? 'active' : 'inactive'}`)
      
      if (isActive) {
        tab.classList.add("active")
        tab.classList.remove("inactive")
        tab.setAttribute("aria-selected", "true")
      } else {
        tab.classList.remove("active") 
        tab.classList.add("inactive")
        tab.setAttribute("aria-selected", "false")
      }
    })

    // Update panels
    this.panelTargets.forEach(panel => {
      const isActive = panel.dataset.tab === selectedTab
      console.log(`Panel ${panel.dataset.tab}: ${isActive ? 'visible' : 'hidden'}`)
      
      if (isActive) {
        panel.classList.remove("hidden")
        panel.classList.add("block")
        panel.setAttribute("aria-hidden", "false")
      } else {
        panel.classList.add("hidden")
        panel.classList.remove("block")
        panel.setAttribute("aria-hidden", "true")
      }
    })

    // Dispatch custom event for other controllers to react
    this.dispatch("tabChanged", { 
      detail: { 
        selectedTab: selectedTab,
        previousTab: this.currentTab 
      } 
    })

    this.currentTab = selectedTab
  }

  // Handle keyboard navigation
  keydown(event) {
    const currentIndex = this.tabTargets.findIndex(tab => 
      tab.classList.contains("active")
    )
    
    let newIndex = currentIndex

    switch(event.key) {
      case "ArrowLeft":
        newIndex = currentIndex > 0 ? currentIndex - 1 : this.tabTargets.length - 1
        break
      case "ArrowRight": 
        newIndex = currentIndex < this.tabTargets.length - 1 ? currentIndex + 1 : 0
        break
      case "Home":
        newIndex = 0
        break
      case "End":
        newIndex = this.tabTargets.length - 1
        break
      default:
        return
    }

    event.preventDefault()
    this.tabTargets[newIndex].click()
    this.tabTargets[newIndex].focus()
  }

  // Initialize tab from URL hash
  showTabFromHash() {
    const hash = window.location.hash.slice(1)
    if (hash && this.tabTargets.some(tab => tab.dataset.tab === hash)) {
      this.show({ currentTarget: { dataset: { tab: hash } } })
    }
  }
}